import React, { useState } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import carousel styles
import { Carousel } from 'react-responsive-carousel';

const carouselMessages = [
  "Wake up to the sound of waves.",
  "Enjoy a refreshing swim in our pool.",
  "Find peace in our lush serene garden."
];

function Home() {

  const [currentSlide, setCurrentSlide] = useState(0);
  const [showBanner, setShowBanner] = useState(true);
  
  return (

    
    <div className="p-10 text-center">
      {/* Under construction banner */}
      {showBanner && (
        <div className="max-w-3xl mx-auto mb-6 px-4 py-3 rounded flex items-center justify-between bg-yellow-100 border border-yellow-300 text-yellow-800">
          <div className="text-left">
            <strong>Under construction:</strong> Some pages and features may be incomplete.
          </div>
          <button
            onClick={() => setShowBanner(false)}
            aria-label="Close banner"
            className="ml-4 text-yellow-800 font-bold px-2 py-1 rounded hover:bg-yellow-200"
          >
            ×
          </button>
        </div>
      )}
      <h1 className="text-3xl font-bold text-blue-900">Welcome to Cidade Serena Guesthouse</h1>
      <p className="mt-4 text-gray-700">Relax by the Atlantic Ocean with breathtaking sunsets.</p>

            {/* Changing Message */}
      <div className="mt-8 mb-4 text-lg text-blue-700 font-semibold transition-all duration-500">
        {carouselMessages[currentSlide]}
      </div>


      {/* Carousel Section */}
      <div className="mt-10 mx-auto max-w-3xl">
        <Carousel
          autoPlay
          infiniteLoop
          showThumbs={false}
          showStatus={false}
          interval={4000}
          transitionTime={700}
          //className="rounded-lg shadow-lg"
          selectedItem={currentSlide}
          onChange={setCurrentSlide}
          showIndicators={true}
        >
          <div className="h-full">
            <img src="/images/drone_view_with_sea.jpg" alt="Ocean" />
            <p className="legend">A serene seaside location</p>
          </div>
          <div className="h-full">
            <img src="/images/pool.jpg" alt="Pool" />
            <p className="legend">Take a refreshing dip in our pool</p>
          </div>
          <div className="h-full">
            <img src="/images/exterior_from_driveway.jpg" alt="Garden" />
            <p className="legend">Enjoy the lush surroundings</p>
          </div>
          <div className="h-full">
            <img src="/images/palm_trees_from_balcony.jpg" alt="Garden" />
            <p className="legend">Enjoy the view</p>
          </div>
          <div className="h-full">
            <img src="/images/mountain_view.jpg" alt="Garden" />
            <p className="legend">Partake in the scenic countryside</p>
          </div>
          <div className="h-full">
            <img src="/images/garden_pool_over_veranda.jpg" alt="Garden" />
            <p className="legend">Garden and Pool View</p>
          </div>
 
        </Carousel>
      </div>
    </div>
  );
}

export default Home;

